// Phase 1 Team Members (Hardcoded)
export const phase1Team = [
  {
    Full_Name: "Max Angelo D. Perin",
    Role: "Project Leader/Fullstack Developer",
    Photo_URL: "/developers/max.jpg"
  },
  {
    Full_Name: "Imelida G. Torrefranca",
    Role: "Project Leader",
    Photo_URL: "/developers/imelda.jpg"
  },
  {
    Full_Name: "Jorge P. Cabelin jr.",
    Role: "Project Leader",
    Photo_URL: "/developers/jorge.jpg"
  },
  {
    Full_Name: "Kathlyn L. Quion",
    Role: "Project Leader",
    Photo_URL: "/developers/kathlyn.jpg"
  },
  {
    Full_Name: "Gladys R. Cabelin",
    Role: "Project Leader",
    Photo_URL: "/developers/gladys.jpg"
  },
  {
    Full_Name: "Jeomar E. Avergonzado",
    Role: "Project Leader",
    Photo_URL: "/developers/jeomar.jpg"
  },
  {
    Full_Name: "Benjie",
    Role: "Assistant Developer",
    Photo_URL: "/developers/benjie.jpg"
  }
];

// Phase 2 Team Members (Static Fallback & Archive)
export const phase2Team = [
  {
    Team_Member_ID: 1,
    Full_Name: "Jeffrey Peresores",
    Role: "Project Leader/Lead Developer",
    Photo_URL: "/developers/Jeffrey.jpg"
  },
  {
    Team_Member_ID: 2,
    Full_Name: "Leizyl Clavite",
    Role: "Frontend Developer",
    Photo_URL: "/developers/leizyl.jpg"
  },
  {
    Team_Member_ID: 3,
    Full_Name: "Garlyn Gail Garay",
    Role: "Data Specialist",
    Photo_URL: "/developers/Garlyn.jpg"
  },
  {
    Team_Member_ID: 4,
    Full_Name: "Crismilyn Ido",
    Role: "UI/UX Designer",
    Photo_URL: "/developers/crismilyn.jpg"
  },
  {
    Team_Member_ID: 5,
    Full_Name: "Jhon Meckael Bunao",
    Role: "Assistant Project Leader",
    Photo_URL: "/developers/bunao.jpg"
  },
  {
    Team_Member_ID: 8,
    Full_Name: "Marlz Jacob Quilario",
    Role: "Backend/Database",
    Photo_URL: "/developers/marlz.jpg"
  },
  {
    Team_Member_ID: 9,
    Full_Name: "Angel Mae Digal Barro",
    Role: "Backend/Database",
    Photo_URL: "/developers/angel.jpg"
  },
  {
    Team_Member_ID: 10,
    Full_Name: "Riza Valentos Ruta",
    Role: "Backend",
    Photo_URL: "/developers/riza.jpg"
  },
  {
    Team_Member_ID: 11,
    Full_Name: "James Panuncialman",
    Role: "Backend",
    Photo_URL: "/developers/james.jpg"
  },
  {
    Team_Member_ID: 6,
    Full_Name: "Max Angelo D. Perin",
    Role: "Project Adviser",
    Photo_URL: "/developers/max.jpg"
  },
  {
    Team_Member_ID: 7,
    Full_Name: "Imelda G. Torrefranca",
    Role: "Project Leader",
    Photo_URL: "/developers/imelda.jpg"
  },
  {
    Team_Member_ID: 12,
    Full_Name: "Jorge P. Cabelin",
    Role: "Project Leader",
    Photo_URL: "/developers/jorge.jpg"
  },
  {
    Team_Member_ID: 13,
    Full_Name: "Kathlyn L. Quion",
    Role: "Project Leader",
    Photo_URL: "/developers/kathlyn.jpg"
  },
  {
    Team_Member_ID: 14,
    Full_Name: "Gladys R. Cabelin",
    Role: "Project Leader",
    Photo_URL: "/developers/gladys.jpg"
  },
  {
    Team_Member_ID: 15,
    Full_Name: "Jeomar E. Avergonzado",
    Role: "Project Leader",
    Photo_URL: "/developers/jeomar.jpg"
  }
];

// Phase 3 Team Members (Hardcoded)
export const phase3Team = [
  {
    Full_Name: "Jeffrey Peresores",
    Role: "Proj Leader/Fullstack Dev",
    Photo_URL: "/developers/jeff.png"
  },
  {
    Full_Name: "Jade Madijanon",
    Role: "UI/UX Designer",
    Photo_URL: "/developers/jade.jpg"
  },
  {
    Full_Name: "Danica Cardaña",
    Role: "Data Analyst",
    Photo_URL: "/developers/danica.png"
  },
   {
    Full_Name: "James Ronolo",
    Role: "Backend Developer",
    Photo_URL: "/developers/james.jpg"
  },
  {
    Full_Name: "John Geraldez",
    Role: "Backend Developer",
    Photo_URL: "/developers/john.png"
  },
   {
    Full_Name: "Ket Guenefer Jaya",
    Role: "Database",
    Photo_URL: "/developers/ket.png"
  },
  {
    Full_Name: "Regie Bago Gelsano",
    Role: "Database",
    Photo_URL: "/developers/regie.png"
  },
  {
    Full_Name: "Max Angelo Perin",
    Role: "Project Adviser",
    Photo_URL: "/developers/max.jpg"
  },
  {
    Full_Name: "Imelida G. Torrefranca",
    Role: "Project Leader",
    Photo_URL: "/developers/imelda.jpg"
  },
  {
    Full_Name: "Jorge P. Cabelin jr.",
    Role: "Project Leader",
    Photo_URL: "/developers/jorge.jpg"
  },
  {
    Full_Name: "Kathlyn L. Quion",
    Role: "Project Leader",
    Photo_URL: "/developers/kathlyn.jpg"
  },
  {
    Full_Name: "Gladys R. Cabelin",
    Role: "Project Leader",
    Photo_URL: "/developers/gladys.jpg"
  },
  {
    Full_Name: "Jeomar E. Avergonzado",
    Role: "Project Leader",
    Photo_URL: "/developers/jeomar.jpg"
  }
];

// Phase 4 Team Members (Hardcoded)
export const phase4Team = [
  {
    Full_Name: "Jeffrey Peresores",
    Role: "Analyst",
    Photo_URL: "/developers/jeff.png"
  },
  {
    Full_Name: "James Ronolo",
    Role: "Proj Leader/Fullstack Dev",
    Photo_URL: "/developers/james1.jpg"
  },
  {
    Full_Name: "Gello Rana",
    Role: "UI/UX Designer",
    Photo_URL: "/developers/gelou1.jpg"
  },
  {
    Full_Name: "Mary Rhose Shary Sagosoy",
    Role: "Data Analyst",
    Photo_URL: "/developers/shary1.jpg"
  },
  {
    Full_Name: "Madona Hilot",
    Role: "Backend Developer",
    Photo_URL: "/developers/madona.jpg"
  },
  {
    Full_Name: "Versan Balais",
    Role: "Database",
    Photo_URL: "/developers/versan.png"
  },
  {
    Full_Name: "Max Angelo Perin",
    Role: "Project Adviser",
    Photo_URL: "/developers/max.jpg"
  },
  {
    Full_Name: "Imelida G. Torrefranca",
    Role: "Project Leader",
    Photo_URL: "/developers/imelda.jpg"
  },
  {
    Full_Name: "Jorge P. Cabelin jr.",
    Role: "Project Leader",
    Photo_URL: "/developers/jorge.jpg"
  },
  {
    Full_Name: "Kathlyn L. Quion",
    Role: "Project Leader",
    Photo_URL: "/developers/kathlyn.jpg"
  },
  {
    Full_Name: "Gladys R. Cabelin",
    Role: "Project Leader",
    Photo_URL: "/developers/gladys.jpg"
  },
  {
    Full_Name: "Jeomar E. Avergonzado",
    Role: "Project Leader",
    Photo_URL: "/developers/jeomar.jpg"
  },
  {
    Full_Name: "Jemuel Cabacoy",
    Role: "TWG Frontend",
    Photo_URL: "/developers/jim.jpg"
  },
  {
    Full_Name: "Heart Ramirez",
    Role: "TWG Frontend",
    Photo_URL: "/developers/heart.jpg"
  }
];
